(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvExpandoHeader', drvExpandoHeader);

    drvExpandoHeader.$inject = [];
    drvExpandoHeader.$inject = [];

    /**
     * Header for an expando section.
     *
     * # Scope Properties
     * {string} label - The label which is to be used for the header.
     * {bool} expanded - Should the expando be expanded.
     */
    function drvExpandoHeader() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvExpandoHeaderCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                label: '<',
                expanded: '='
            },
            template:
                '<span ng-click="drvCtrl.toggleExpando()">' +
                '{{drvCtrl.label}}' +
                '<drv-icon ng-if="!drvCtrl.expanded" usage="\'chevron down\'"></drv-icon>' +
                '<drv-icon ng-if="drvCtrl.expanded" usage="\'chevron up\'"></drv-icon>' +
                '</span>'
        };
        return directive;
    }

    function drvExpandoHeaderCtrl() {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.toggleExpando = toggleExpando;

        function toggleExpando() {
            if (drvCtrl.expanded) {
                drvCtrl.expanded = false;
            } else {
                drvCtrl.expanded = true;
            }
        }
    }
})();